

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import _ from "lodash";
import RequestRepository from "@/repositories/request/RequestRepository";
import { User as IAssignedUser, Uuidable } from "@/modules/request/Request";
import { User } from "front-component/modules/User";
import EventBus from "front-component/EventBus";

const components = {
};

@Component({ components })
export default class AssignedUsers extends Vue {
    private assignedUsers: IAssignedUser[] = [];
    private loading: boolean = true;
    @Prop(String) private requestUuid!: string;

    @Getter("getCurrentUser") public currentUser!: User;

    @Watch("requestUuid") private changeRequest() {
        this.updateAssignedUsers();
    }

    private mounted() {
        this.updateAssignedUsers();
    }

    private get alreadyAssigned(): boolean {
        return !!this.currentUser.department && -1 !== _.findIndex(this.assignedUsers, (user: IAssignedUser) => {
            return user.uuid === this.currentUser.uuid;
        });
    }

    private updateAssignedUsers(afterUpdate: (() => void)|null = null) {
        if (!this.requestUuid) {
            return;
        }

        this.loading = true;
        const assignedUserParams = {
            fields: [
                "uuid",
                "assignedUsers.uuid",
                "assignedUsers.displayName",
            ],
            filters: {
                uuid: this.requestUuid,
            }
        };

        RequestRepository.get(assignedUserParams).then((requests) => {
            this.assignedUsers = _.get(requests, "0.assignedUsers", []);
            if (!_.isNull(afterUpdate)) {
                afterUpdate();
            } else {
                this.loading = false;
            }
        });
    }

    private assignedMe(): void {
        this.updateAssignedUsers(() => {
            if (this.alreadyAssigned) {
                this.loading = false;
                return;
            }

            const assignedUserParams = {
                fields: [
                    "uuid",
                    "assignedUsers.uuid",
                    "assignedUsers.displayName",
                ]
            };

            const assignedUsersData = {
                uuid: this.requestUuid,
                assignedUsers: _.reduce(
                    this.assignedUsers,
                    (accumulator: Uuidable[], user: IAssignedUser): Uuidable[] => {
                        const userUuid = _.get(user, "uuid", null);
                        if (userUuid) {
                            accumulator.push({ uuid: userUuid });

                            return accumulator;
                        }
                        return accumulator;
                    },
                    []
                ),
            };

            assignedUsersData.assignedUsers.push({ uuid: this.currentUser.uuid });

            RequestRepository.save(assignedUsersData, assignedUserParams).then((request) => {
                this.assignedUsers = _.get(request, "assignedUsers", []);
                this.loading = false;
                EventBus.$emit("request-assigned-updated", this.requestUuid);
            });
        });
    }
}
